<template>
    <div class="column-area">
      <div class="wrapper_main">
        <div class="paper_title">
          <span class="title_font"><a @click="clickReturnHome">首页-></a></span>
          <span class="title_font">{{selectCategory}}</span>
        </div>
        <!-- 列表区域  -->
        <div class="pager-list">
          <!-- 列表区域  -->
          <el-row>
            <el-col :span="4.6" v-for = "(item,index) in searchDataList" :key="item.id"  :offset="index === 0 ? 0 : (index%5 === 0 ? 0:0.8)" > <!--:offset="index%3"-->
              
              <el-card  class="book-card" :body-style="{ padding: '0px' }"  @click.native="openResourceByConver(index)"  title="点击阅读">
                <a href="#"><img class="book-cover" :src="item.virtualRoute+item.resourceCover"/></a>
                <span class="book_favitor" v-if="item.state==1"><i class="iconfont icon-award-fill"/></span>
                <span class="book_type" v-if="item.resourceType == 1">古籍</span>
                <span class="book_type" v-else-if="item.resourceType == 2">报刊</span>
                <span class="book_type" v-else-if="item.resourceType == 3">图书</span>
                <span class="book_type" v-else>其他</span>
                <span class="book_title"><a href="#">{{item.resourceName}}</a></span>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div style="..."></div>
        <div style="height: 63px"></div>
        <!--分页-->
        <div class="paging-set mb20">
          <el-pagination class="pagiing-num mb20"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryEntity.current"
            :page-sizes="[15, 30, 45, 60, 75]"
            :page-size="queryEntity.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="queryEntity.total">
          </el-pagination>
        </div>
      </div>
    </div>
</template>

<script>
  import resourceApi from "@/api/resource"
  import detailApi from "@/api/detail"
  import {confirm,pageParamNames} from '@/utils/constants'

  export default {
    name: 'searchList',
    data() {
      return{
        tableLoading: false,
        selectCategory: null,
        searchDataList:[],
        splitPageType:0,
        queryEntity:{
          keyword: null,
          current: 1,
          pages: null,
          sizes: 15,
          total: 0,
          extStr: null,
          orderField: "resourceType",
        }
      }
    },
    inject: ["provideData"],
    props: {
      dataList: {
        type:[Object]
      }
    },
    created() {
      this.initData()
    },
    mounted(){
      console.log('search list param:  ',this.dataList.title);
    },
    methods:{
      initData(){
        this.queryEntity.keyword= null;
        this.queryEntity.current= 1;
        this.queryEntity.pages= null;
        this.queryEntity.sizes= 15;
        this.queryEntity.total= 0;
        //this.queryEntity.orderField= "useCount";
        this.queryEntity.orderField= "resourceType";
      },
      queryDataByCategory(categoryCode,categoryName,dbGuid){
        this.queryEntity.keyword = categoryCode;
        this.selectCategory = categoryName;
        this.queryEntity.sizes= 15;
        this.queryEntity.extStr = dbGuid;
        this.splitPageType = 0
        console.log('query category event: ',this.queryEntity)
        resourceApi.getResourceByLikeCategoryCode(this.queryEntity).then(res => {
          this.searchDataList = res.data.data.list;
          this.tableLoading = false;
          pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
        })
      },
      queryDataByTitle(searchType,categoryCode,resourceTitle){
        console.log('query categoryCode after : ',categoryCode,resourceTitle)
        this.queryEntity.keyword = resourceTitle;
        this.queryEntity.extStr = categoryCode;
        this.queryEntity.extInt = searchType;
        this.queryEntity.sizes= 15;
        this.splitPageType = 1
        this.selectCategory = '检索词：' + resourceTitle;
        //关键字检索不加分类
        console.log('query title event: ',this.queryEntity)
        resourceApi.getResourceByCategoryCodeAndResourceName(this.queryEntity).then(res => {
          this.searchDataList = res.data.data.list;
          this.tableLoading = false;
          pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
        })
      },
      clickReturnHome(){
        this.$emit('clickReturnHome','')
      },
      //分页
      handleSizeChange(val) {
        this.queryEntity.sizes = val;
        this.queryEntity.extStr = null;
        console.log('page event: ',this.queryEntity)
        if (this.splitPageType == 0){
          resourceApi.getResourceByLikeCategoryCode(this.queryEntity).then(res => {
            this.searchDataList = res.data.data.list;
            this.tableLoading = false;
            pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
          })
        }else{
          resourceApi.getResourceByCategoryCodeAndResourceName(this.queryEntity).then(res => {
            this.searchDataList = res.data.data.list;
            this.tableLoading = false;
            pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
          })
        }
      },
      handleCurrentChange(val) {
        this.queryEntity.current = val;
        this.queryEntity.extStr = null;
        console.log('page event: ',this.queryEntity)
        if (this.splitPageType == 0){
            resourceApi.getResourceByLikeCategoryCode(this.queryEntity).then(res => {
            this.searchDataList = res.data.data.list;
            this.tableLoading = false;
            pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
          })
        }else{
          resourceApi.getResourceByCategoryCodeAndResourceName(this.queryEntity).then(res => {
            this.searchDataList = res.data.data.list;
            this.tableLoading = false;
            pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
          })
        }
      },
      queryWordBookColumn() {
        alert(this.dataList.queryWord);
      },
      // openResourceByConver: function (index) {
      //   const href = this.searchDataList[index].virtualRoute+this.searchDataList[index].resourceAddress;
      //   window.open(href, '_blank');
      //   this.tableLoading = false;
      // },
      openResourceByConver:function(index){
        let bookGuid = this.searchDataList[index].guid
        let bookName = this.searchDataList[index].resourceName
        let bookState = this.searchDataList[index].state
        if (bookState == undefined || bookState == null){
          bookState = 0
        }
        let bookUrl = this.searchDataList[index].virtualRoute+this.searchDataList[index].resourceAddress;
        //let bookUrl = "bookvirtual/8ef221e60c66444984539a6afd19RjheZPXr/1c300a8ea3f04761bc65c7fd8a48QfrUvc5T/09011927.pdf"
        const { href } = this.$router.resolve({
          name: "readpage",
          query: {
            bookGuid:bookGuid,
            bookName:bookName,
            bookState:bookState,
            bookUrl:bookUrl,
          },
        });
        window.open(href, '_blank');
        this.tableLoading = false;
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import url('../../styles/common.css');
  @import url('../../styles/main.css');
</style>



// WEBPACK FOOTER //
// src/view/column/searchList.vue